/**
 * Trims leading/trailing whitespace and removes carriage returns and newlines.
 * Use for first_name, last_name, email and similar fields to avoid paste-induced characters.
 */
export function trimField(value: string): string {
  if (value == null || typeof value !== 'string') return value;
  return value.replace(/\r|\n/g, '').trim();
}

/**
 * Replace newlines/tabs with spaces and collapse runs of spaces.
 * Does not trim — safe for live text input (event/agenda descriptions).
 */
export function normalizePlainTextInput(value: string): string {
  if (value == null || typeof value !== 'string') return value;
  return value.replace(/[\r\n\t]+/g, ' ').replace(/ {2,}/g, ' ');
}

/** Normalize then trim — use when saving event/agenda descriptions. */
export function normalizePlainText(value: string): string {
  return normalizePlainTextInput(value).trim();
}
